import { createTheme, ThemeOptions } from '@mui/material/styles';
import { overrides } from './overrides';
import { palette } from './palette';
import { typography } from './typography';

const themeOptions: ThemeOptions = {
  palette,
  typography,
  breakpoints: {
    values: {
      xs: 375,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    ...overrides,
    MuiCssBaseline: {
      styleOverrides: `
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        
        :root {
          font-size: 62.5%; /* 10px */
        }
           html, body, #root {
          margin: 0;
          padding: 0;
          width: 100%;
          height: 100%;
          overflow-x: hidden;
        }
        body {
          font-size: 1.6rem; /* 16px */
          font-family: 'Inter, Arial, sans-serif';
        }
            * {
          box-sizing: border-box;
        }
           @media (max-width: 640px) {
      .slick-arrow {
        display: none !important;
      }
    }
      `,
    },
  },
};

export const theme = createTheme(themeOptions);
